<template>
    <div class="flex flex-wrap gap-2 space-x-8 justify-center">
        <tooltip no-arrow content="Facebook" position="top" v-if="view('facebook')">
            <svg-icon type="facebook-color" class="w-18 h-18"/>
        </tooltip>
        <tooltip no-arrow content="Google" position="top" v-if="view('google')">
            <svg-icon type="google-color" class="w-18 h-18"/>
        </tooltip>
        <tooltip no-arrow content="Instagram" position="top" v-if="view('instagram')">
            <svg-icon type="instagram" class="w-18 h-18 instagram"/>
        </tooltip>
        <tooltip no-arrow content="Stepstone" position="top" v-if="view('stepstone')">
            <svg-icon type="stepstone-color" class="w-18 h-18"/>
        </tooltip>
        <tooltip no-arrow content="Indeed" position="top" v-if="view('indeed')">
            <svg-icon type="indeed-color" class="w-18 h-18"/>
        </tooltip>
        <tooltip no-arrow content="LinkedIn" position="top" v-if="view('linkedin')">
            <svg-icon type="linkedin-color" class="w-18 h-18"/>
        </tooltip>
    </div>
</template>

<script>
import SvgIcon from './ui/SvgIcon.vue';
import Tooltip from '../components/navigation/Tooltip.vue';

export default {
    components: {SvgIcon, Tooltip},
    props: {
        campaignPackageId: {type: Number, default: null},
    },
    methods: {
        view(type) {
            /**
             * 1 = 1016465747 (blue - medium boost)
             * 2 = 2009270452 (blue - large boost)
             * 3 = 775686169 (blue - large boost)
             * 4 = 1634274170 (white - small boost)
             * 5 = 408554207 (white - large boost)
             * 6 = 1385630240 (white - large boost)
             */

            switch (type) {
                case 'facebook':
                    return this.campaignPackageId === 1016465747 ||
                        this.campaignPackageId === 2009270452 ||
                        this.campaignPackageId === 775686169 ||
                        this.campaignPackageId === 1634274170 ||
                        this.campaignPackageId === 408554207 ||
                        this.campaignPackageId === 1385630240;
                case 'google':
                    return this.campaignPackageId === 1016465747 ||
                        this.campaignPackageId === 2009270452 ||
                        this.campaignPackageId === 775686169 ||
                        this.campaignPackageId === 408554207 ||
                        this.campaignPackageId === 1385630240;
                case 'instagram':
                    return this.campaignPackageId === 408554207 ||
                        this.campaignPackageId === 2009270452 ||
                        this.campaignPackageId === 775686169 ||
                        this.campaignPackageId === 1385630240;
                case 'stepstone':
                    return this.campaignPackageId === 775686169 ||
                        this.campaignPackageId === 1385630240;
                case 'indeed':
                    return this.campaignPackageId === 2009270452 ||
                        this.campaignPackageId === 775686169;
                case 'linkedin':
                    return this.campaignPackageId === 1634274170 ||
                        this.campaignPackageId === 408554207 ||
                        this.campaignPackageId === 1385630240;
                default:
                    return false;
            }

        }
    }
}
</script>
<style>
.instagram {
    background: #d6249f;
    background: radial-gradient(circle at 45% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%, #d6249f 60%, #285AEB 90%);
    border-radius: 50%;
    color: transparent !important;
}
</style>
